import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { MeshPhysicalMaterial, MeshStandardMaterial } from "three";
import {
  defaultDoorWidth,
  defaultJHandleYPosition,
} from "shared/utils/doorSceneConstants";
import { TaatsGLTFResult } from "../TaatsType";
import { ScharnierGLTFResult } from "../../scharnier/ScharnierType";

// Full offset config per door code
const HANDLE_X_OFFSETS: Record<
  string,
  { base: number; secondLeaf?: number; firstLeaf?: number }
> = {
  // Special case with two-leaf dependent offsets
  dubbel2paneel: {
    base: 0.015,
    firstLeaf: -0.011, // doorIndex 0 or 1 (left)
    secondLeaf: 0.008, // doorIndex > 1 (right)
  },

  // Default behavior for all other doors
  default: {
    base: 0.005,
  },
};
export const HandleSmalRond = ({
  chosenMaterial,
  nodes,
  doorIndex,
}: {
  chosenMaterial: MeshPhysicalMaterial | MeshStandardMaterial;
  nodes: TaatsGLTFResult["nodes"] | ScharnierGLTFResult["nodes"];
  doorIndex: number;
}) => {
  const { getConfigurationWidth, selectedDoor } =
    useConfigurationOptionsContext();

  const scaleDoorX = getConfigurationWidth(doorIndex) / defaultDoorWidth;

  const handleSmalRondY = defaultJHandleYPosition / 1000;

  const doorCode = selectedDoor?.code || "";
  // Pick config
  const cfg = HANDLE_X_OFFSETS[doorCode] ?? HANDLE_X_OFFSETS["default"];

  /** Base */
  const xAdjust = cfg.base;

  /** Door nr. specific */
  const isSecondLeaf = doorIndex > 1;
  const xAdj2 = isSecondLeaf ? (cfg.secondLeaf ?? 0) : (cfg.firstLeaf ?? 0);

  return (
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.handle_smal_rond.geometry}
      material={chosenMaterial}
      // original y: 1.292
      // position adjusted to match the smalle greup: 1.15
      position={[-0.434 * scaleDoorX + xAdjust + xAdj2, handleSmalRondY, 0]}
    />
  );
};
